// React Dependencies
import React from 'react';

// Internal Dependencies
import ReviewsTable from './table';
import FlaggedReviewsTable from './flaggedReviews';
import MasterReview from './masterReview';

const ReviewsList = () => (
  <div>
    <>
      <div className="content-header">
        <h1>Reviews</h1>
      </div>
      <FlaggedReviewsTable />
      <MasterReview />
      <ReviewsTable />
    </>
  </div>
);

export default ReviewsList;
